import { useState } from "react";

const contacts = [
  { label: "合作邮箱", value: "hello@yuanzhikong.com", icon: "ri-mail-line" },
  { label: "微信公众号", value: "缘之空官方", icon: "ri-wechat-line" },
  { label: "内容反馈", value: "feedback@yuanzhikong.com", icon: "ri-feedback-line" },
];

export default function SiteIntro() {
  const [copied, setCopied] = useState<string | null>(null);

  const handleCopy = async (value: string) => {
    try {
      await navigator.clipboard.writeText(value);
    } catch {
      // 忽略剪贴板不可用的场景，仍给出复制提示
    }
    setCopied(value);
    window.setTimeout(() => setCopied(null), 1800);
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-start">
      <div>
        <h2 className="font-heading font-black text-foreground-950 text-xl md:text-3xl">
          关于缘之空
        </h2>
        <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
          缘之空是一家专注影视内容展示的平台，服务热爱电影与电视剧的观众。
          我们将影视作品的海报、剧情简介、演员与制作信息整理成清晰易读的页面，
          让用户在观影之前就能快速了解一部作品的风格与故事，从而做出更合适的选择。
        </p>
        <p className="mt-3 text-sm md:text-base text-foreground-700 leading-relaxed">
          我们覆盖国产与海外的电影、电视剧内容，并持续更新最新的热门作品。
          本站不提供播放与下载功能，只专注于高清资源的展示与剧情的深度解析。
        </p>
        <div className="mt-6 flex flex-wrap gap-3">
          <span className="px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-900 text-xs">
            持续更新中
          </span>
          <span className="px-3 py-1.5 rounded-full bg-accent-100 text-accent-900 text-xs">
            高清海报展示
          </span>
          <span className="px-3 py-1.5 rounded-full bg-primary-50 text-primary-700 text-xs">
            剧情深度解析
          </span>
        </div>
      </div>

      <div className="bg-background-50 border border-background-200 rounded-lg p-5 md:p-6">
        <h3 className="font-heading font-bold text-foreground-950 mb-1">联系方式</h3>
        <p className="text-xs text-foreground-500 mb-4">点击即可复制，欢迎与我们联系</p>
        <ul className="space-y-3">
          {contacts.map((item) => (
            <li key={item.label}>
              <button
                type="button"
                onClick={() => handleCopy(item.value)}
                className="w-full flex items-center gap-3 p-3 rounded-md border border-background-200 hover:border-primary-200 hover:bg-primary-50 transition-colors text-left cursor-pointer"
              >
                <span className="w-10 h-10 rounded-md bg-primary-50 flex items-center justify-center shrink-0">
                  <i className={`${item.icon} text-lg text-primary-500`}></i>
                </span>
                <span className="min-w-0 flex-1">
                  <span className="block text-xs text-foreground-500">{item.label}</span>
                  <span className="block text-sm font-medium text-foreground-900 truncate">
                    {item.value}
                  </span>
                </span>
                <i
                  className={`shrink-0 text-lg ${
                    copied === item.value ? "ri-check-line text-accent-500" : "ri-file-copy-line text-foreground-400"
                  }`}
                ></i>
              </button>
            </li>
          ))}
        </ul>
        <p className="mt-4 text-xs text-foreground-400 leading-relaxed">
          注：联系方式仅用于内容交流与合作，本站不受理影视资源索取请求。
        </p>
      </div>
    </div>
  );
}